import {gql} from '@apollo/client';

export const FRAGMENT_LETTER_ITEM = gql`
  fragment LetterItem on LetterType {
    id
    content
    createdAt
    talkId
    isAdmin
    client {
      id
      newCount
      lastLetter {
        id
        isAdmin
      }
      user {
        id
        fullname
        avatar {
          id
          path
        }
      }
    }
  }
`;

export const QUERY_LETTER_LIST = gql`
  query LetterList($talkId: ID, $talkNull: Boolean) {
    letterList(talk: $talkId, talk_Isnull: $talkNull) {
      ...LetterItem
    }
  }
  ${FRAGMENT_LETTER_ITEM}
`;

export const MUTATION_LETTER_SAVE = gql`
  mutation LetterSave($input: LetterSaveInput!) {
    letterSave(input: $input) {
      obj {
        ...LetterItem
      }
    }
  }
  ${FRAGMENT_LETTER_ITEM}
`;
